export default "__VITE_ASSET__db1aaae9__"